import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { partial } from 'lodash';
import PropTypes from 'prop-types';

import { createMonetizationCtaEvent } from 'actions/session';
import { updateLocationSettings } from 'actions/settings';

import { getCurrentUserFirstName } from 'selectors/session';

import Box from 'components/Box';
import Button from 'components/clickables/Button';
import { Mobile } from 'components/MediaQuery';
import Text from 'components/Text';

import cxHelpers from 'util/className';
import * as flashNotice from 'util/flashNotice';
import { toI18n } from 'util/i18n';
import { trackGrowthEvent } from 'util/tracking';
import { PG_TRACK_EVENTS } from 'util/tracking_constants';

const GPS_RADIUS = 50;

@connect(
  (state, props) => ({
    userFirstName: getCurrentUserFirstName(state, props),
  }),
  {
    updateLocationSettings,
    createMonetizationCtaEvent,
  }
)
@cxHelpers('GeofenceOverlay')
export default class GeofenceOverlay extends PureComponent {
  static propTypes = {
    userFirstName: PropTypes.string.isRequired,
    updateLocationSettings: PropTypes.func.isRequired,
    createMonetizationCtaEvent: PropTypes.func.isRequired,
  };

  state = {
    isOpen: true,
  };

  trackEvent = eventAction =>
    trackGrowthEvent({
      productArea: 'Geofence Overlay',
      eventCategory: 'Purchase Funnel',
      eventAction,
      experimentName: 'discoverability_geofence',
    });

  closeOverlay = () => {
    this.props.createMonetizationCtaEvent(PG_TRACK_EVENTS.GEOFENCE_OVERLAY);
    this.setState({ isOpen: false });
  };

  handleClickOverlay = () => {
    this.trackEvent('Close');
    this.closeOverlay();
  };

  handleClickCta = e => {
    e.stopPropagation();
    this.props.updateLocationSettings({
      payload: {
        properties_attributes: {
          gps_radius: GPS_RADIUS,
        },
        proximity_enforcement_enabled: true,
      },
      onSuccess: partial(
        flashNotice.success,
        toI18n('geo_fence_overlay.success')
      ),
    });
    this.trackEvent('Click');
    this.closeOverlay();
  };

  render() {
    if (!this.state.isOpen) return null;

    return (
      <Mobile>
        {mobile => (
          <Box
            bg="rgba(0, 0, 0, 0.9)"
            fixed
            top={0}
            left={0}
            right={0}
            bottom={0}
            z={1000}
            overflow="hidden"
          >
            <Box
              className={this.cx()}
              column
              hcenter
              h="100%"
              onClick={this.handleClickOverlay}
            >
              <Box mt={150} tcenter>
                <img
                  src={require('./images/geofence.svg')}
                  alt="Geo fence feature"
                />
              </Box>
              <Box mt24 w={mobile ? '90%' : '100%'} maxw={548} tcenter>
                <Text
                  i18n="geo_fence_overlay.content"
                  i18nProps={{ first_name: this.props.userFirstName }}
                  fs18
                  white
                />
              </Box>
              <Box mt24 mb={120}>
                <Button
                  i18n="geo_fence_overlay.cta"
                  theme="primary"
                  onClick={this.handleClickCta}
                />
              </Box>
            </Box>
          </Box>
        )}
      </Mobile>
    );
  }
}
